import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {ServerInfoActions} from '../server/serverinfo-actions';
import {DeviceActions} from './device-actions';
import { tap } from 'rxjs/operators';
/**
 * Created by ashok on 10/05/17.
 */

@Injectable()
export class DeviceActionEffects {

    constructor(private actions$: Actions, private deviceActions: DeviceActions){
    }

    versionMatched$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ServerInfoActions.SERVER_INFO_MATCHES_CLIENT), tap((action: Action) => {
                // alert('DeviceActionEffects enter')
                this.deviceActions.detectDevice();
            })
        ), { dispatch: false });


}